import * as actionConstants from "../constants/actionTypes";
import * as generalHelper from "../helpers/generalHelper";
import * as objectTypes from "../constants/objectTypes";
import * as propertyConstants from "../constants/propertyConstants";
import * as reducerHelper from "../helpers/reducerHelper";
import * as tableConstants from "../constants/tableConstants";

import { System, updateSystem } from "../types/system";

export type SystemState = Readonly<{
    allList: Array<System>;
    list: Array<System>;
    activeList: Array<System>;
    active: System | null;
    count: number | null;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    offset: number;
    page: number;
}>;

const initialState: SystemState = {
    allList: [],
    list: [],
    activeList: [],
    active: null,
    count: null,
    search: null,
    searchParams: tableConstants.DEFAULT_SEARCH_PARAMS,
    offset: tableConstants.DEFAULT_OFFSET,
    page: tableConstants.DEFAULT_PAGE
};

export default function systems(state: SystemState = initialState, action: Record<string, any>): SystemState {
    switch (action.type) {
        case actionConstants.LIST_SAVE_NO_PARAMS: {
            if (action.payload.objectType === objectTypes.SYSTEM) {
                const newActive = generalHelper.updateActiveLists(
                    state.active ? [state.active] : [],
                    action.payload.list
                );

                return {
                    ...state,
                    allList: action.payload.list,
                    active: newActive.length ? newActive[0] : null
                };
            }

            if (action.payload.objectType === objectTypes.DATABASE) {
                if (!action.payload.list.length) {
                    return {
                        ...state,
                        allList: initialState.allList,
                        active: initialState.active
                    };
                }

                return state;
            }

            return state;
        }
        case actionConstants.LIST_SAVE: {
            if (action.payload.objectType === objectTypes.SYSTEM) {
                const newActiveList = generalHelper.updateActiveLists(state.activeList, action.payload.list);

                return {
                    ...state,
                    list: action.payload.list,
                    activeList: newActiveList,
                    count: action.payload.totalCount
                };
            }

            return state;
        }
        case actionConstants.SET_ACTIVE: {
            if (action.payload.objectType === objectTypes.SYSTEM) {
                return {
                    ...state,
                    activeList: action.payload.items
                };
            }

            return state;
        }
        case actionConstants.SET_OFFSET: {
            if (action.payload.objectType === objectTypes.SYSTEM) {
                return {
                    ...state,
                    offset: action.payload.offset,
                    page: action.payload.page
                };
            }

            return state;
        }
        case actionConstants.SET_SEARCH: {
            if (action.payload.objectType === objectTypes.SYSTEM) {
                return reducerHelper.getSearchState(
                    action.payload,
                    state,
                    tableConstants.SEARCH,
                    tableConstants.SEARCH_PARAMS
                );
            }

            return state;
        }
        case actionConstants.EDIT: {
            if (!action.payload.isModal) {
                switch (action.payload.objectType) {
                    case objectTypes.SYSTEM: {
                        const updatedSystemList = generalHelper.updateItem(
                            state.list,
                            action.payload.params[propertyConstants.PROPERTY_SYSTEM_ID],
                            action.payload.params[propertyConstants.PROPERTY_DATA],
                            updateSystem
                        );

                        if (updatedSystemList.length) {
                            return {
                                ...state,
                                list: updatedSystemList
                            };
                        }

                        return state;
                    }
                    default: {
                        return state;
                    }
                }
            }
            return state;
        }
        case actionConstants.EDIT_SUCCESS: {
            if (!action.payload.isModal) {
                switch (action.payload.objectType) {
                    case objectTypes.SYSTEM: {
                        return {
                            ...state,
                            list: generalHelper.updateLists(state.list, action.payload.items),
                            activeList: generalHelper.updateActiveLists(state.activeList, action.payload.items)
                        };
                    }
                    default: {
                        return state;
                    }
                }
            }
            return state;
        }
        case actionConstants.NAVIGATION_SET_SCENE:
        case actionConstants.NAVIGATION_SET_WIZARD: {
            return {
                ...initialState,
                allList: state.allList,
                active: state.active
            };
        }
        case actionConstants.EVENT_SAVE_DATABASES: {
            return initialState;
        }
        case actionConstants.EVENT_SAVE_SYSTEMS: {
            return {
                ...state,
                allList: action.payload.systemList,
                active: action.payload.active
            };
        }
        case actionConstants.SERVER_WEBSOCKET_CLOSED: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}
